// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./volldamm.jpg')
const allTwoEs = require('./creativity1.gif')
const allTwoCa = require('./creativity1.gif')
const allFourEs = require('./creativity1.gif')
const allFourCa = require('./creativity1.gif')
const catalogTwoEs = require('./creativity1.gif')
const catalogTwoCa = require('./creativity1.gif')
const catalogFourEs = require('./creativity1.gif')
const catalogFourCa = require('./creativity1.gif')

const model = creativityMediaModel({ catalogID: 'beer', allTwoEs, allTwoCa, allFourEs, allFourCa, catalogTwoEs, catalogTwoCa, catalogFourEs, catalogFourCa })

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) => model[params.catalogID][params.numberOfColumns][params.language]
}
